// ── 이번달 계약 패널 공용 헬퍼 (2026-06-07 분리) ─────────────────────────────
// ContractPanels.jsx (319줄) 분리 — 데스크탑/모바일 표 양쪽에서 동일하게 사용.

export const fmt = (value) => Number(value || 0).toLocaleString('ko-KR', { maximumFractionDigits: 2 });

export function metricValue(row, column) {
  if (column.kind === 'product') return Number(row.products?.[column.key] || 0);
  if (column.kind === 'category') return Number(row.categories?.[column.key] || 0);
  if (column.kind === 'total') return Number(row.total || 0);
  return 0;
}

// 사용자 명세 (2026-06-09): "제주" 카테고리 컬럼은 "조식VIP(고)" 바로 옆에 위치.
// 그 외 카테고리는 productColumns 뒤에 일반 정렬.
export function buildColumns(productColumns, categoryColumns) {
  const products = (productColumns || []).map((col) => ({ ...col, kind: 'product' }));
  const categories = (categoryColumns || []).map((col) => ({ ...col, kind: 'category', accent: true }));

  const jejuIdx = categories.findIndex((c) => c.label === '제주');
  const insertIdx = products.findIndex((p) => p.label === '조식VIP(고)');
  if (jejuIdx !== -1 && insertIdx !== -1) {
    const [jeju] = categories.splice(jejuIdx, 1);
    products.splice(insertIdx + 1, 0, jeju);
  }

  return [
    ...products,
    ...categories,
    { key: 'total', label: '계', kind: 'total', bold: true },
  ];
}

export function sumRows(rows, columns) {
  return columns.reduce((acc, column) => {
    acc[column.key] = (rows || []).reduce((sum, row) => sum + metricValue(row, column), 0);
    return acc;
  }, {});
}
